import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import { IRule } from 'libs/shared/src/lib/rules-component/rules-component.model';

export interface CriteriaConditionTypeProps {
  objectOptions: IOption[];
  formPath: string;
  IsLoadingActionData?: boolean;
  actionsOptions?: IOption[];
  objectName: string;
}

export enum CriteriaConditionType {
  When = '1',
  Never = '0',
  Always = '2',
}

// For the form
interface IEntryCriteriaRelatedObject {
  object: string;
  comparision: string;
  stage: IOption[];
  isPerformOnConditions: boolean;
  conditions: IRule[];
  relationshipName: string;
  relationShipType: string;
}

export interface CriteriaConfig {
  type: string;
  errorMessage?: string;
  validations: IEntryCriteriaRelatedObject;
}

export interface CriteriaDefinition {
  conditionType: CriteriaConditionType;
  performOnConditions: IRule[];
  criteria: CriteriaConfig[];
}

// Form the payload
export interface CriteriaConditionPayloadType {
  performOnConditions: any;
  validations: CriteriaValidations[];
}

interface RelatedObjectStateConfig {
  objectName: string;
  relationShipName: string;
  relationShipType: string;
  comparision: string;
  statesLabel: string[];
  conditions?: any;
}

export interface CriteriaValidations {
  type: string;
  config: RelatedObjectStateConfig;
  errorMessage?: string;
}
